import { render, staticRenderFns } from "./HeadphonesIcon.vue?vue&type=template&id=70cdf838&scoped=true&"
import script from "./HeadphonesIcon.vue?vue&type=script&lang=js&"
export * from "./HeadphonesIcon.vue?vue&type=script&lang=js&"
import style0 from "./HeadphonesIcon.vue?vue&type=style&index=0&id=70cdf838&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cdf838",
  null
  
)

export default component.exports